import React from "react";
import { useInView } from "react-intersection-observer";
import { ReactComponent as RogIcon } from "../assets/icons/rog.svg";
import { ReactComponent as RubyGem } from "../assets/gems/ruby.svg";
import { ReactComponent as CitrineGem } from "../assets/gems/citrine.svg";
import { ReactComponent as TopazGem } from "../assets/gems/topaz.svg";
import { ReactComponent as EmeraldGem } from "../assets/gems/emerald.svg";
import { ReactComponent as AquamarineGem } from "../assets/gems/aquamarine.svg";
import { ReactComponent as TanzaniteGem } from "../assets/gems/tanzanite.svg";
import { ReactComponent as AmethystGem } from "../assets/gems/amethyst.svg";
import { ReactComponent as DownArrow } from "../assets/icons/arrows/down.svg";

function VirtualGood() {
  const { ref: desktopHeadingRef, inView: desktopHeadingInView } = useInView({
    triggerOnce: true,
    threshold: 0.5,
  });

  const { ref: mobileHeadingRef, inView: mobileHeadingInView } = useInView({
    triggerOnce: true,
    threshold: 0.5,
  });

  const potentialPoints = [
    "Traditional virtual goods provide momentary enjoyment, then nothing",
    "Generos gems create ongoing earning potential through vault generation",
    "Your purchases fund both social impact and personal rewards",
  ];

  return (
    <section>
      <div
        className="flex w-full max-w-6xl mx-auto px-4 sm:px-6 items-center"
        // data-aos-id-gen-method-anchor
      >
        <div className="border-t border-gray-800 relative mb-10 md:mb-20">
          {/* Gems section */}
          <div className="flex justify-between md:mx-20 mx-6 mt-24">
            <RubyGem
              className="md:w-12 w-6"
              data-aos="fade-up"
              data-aos-anchor={
                desktopHeadingInView || mobileHeadingInView
                  ? "#heading-container"
                  : undefined
              }
            />
            <CitrineGem
              className="md:w-12 w-6"
              data-aos="fade-up"
              data-aos-anchor={
                desktopHeadingInView || mobileHeadingInView
                  ? "#heading-container"
                  : undefined
              }
              data-aos-delay="400"
            />
            <TopazGem
              className="md:w-12 w-6"
              data-aos="fade-up"
              data-aos-anchor={
                desktopHeadingInView || mobileHeadingInView
                  ? "#heading-container"
                  : undefined
              }
              data-aos-delay="800"
            />
            <EmeraldGem
              className="md:w-12 w-6"
              data-aos="fade-up"
              data-aos-anchor={
                desktopHeadingInView || mobileHeadingInView
                  ? "#heading-container"
                  : undefined
              }
              data-aos-delay="1200"
            />
            <AquamarineGem
              className="md:w-12 w-6"
              data-aos="fade-up"
              data-aos-anchor={
                desktopHeadingInView || mobileHeadingInView
                  ? "#heading-container"
                  : undefined
              }
              data-aos-delay="1600"
            />
            <TanzaniteGem
              className="md:w-12 w-6"
              data-aos="fade-up"
              data-aos-anchor={
                desktopHeadingInView || mobileHeadingInView
                  ? "#heading-container"
                  : undefined
              }
              data-aos-delay="2000"
            />
            <AmethystGem
              className="md:w-12 w-6"
              data-aos="fade-up"
              data-aos-anchor={
                desktopHeadingInView || mobileHeadingInView
                  ? "#heading-container"
                  : undefined
              }
              data-aos-delay="2400"
            />
          </div>
          <div className="w-full">
            {/* Mobile */}
            <div className="md:hidden flex flex-col items-center">
              <div
                className="flex flex-col items-center"
                data-aos="fade-up"
                data-aos-delay="500"
              >
                <div className="flex flex-col text-center items-start justify-center mt-10">
                  <div id="heading-container">
                    <div
                      ref={mobileHeadingRef}
                      className="h1 mb-6 text-xxl text-white"
                      data-aos="fade-up"
                    >
                      Unlock Virtual Goods That Actually Give Back
                    </div>
                  </div>
                  <p className="text-2xl text-white mb-8">
                    Unlike typical digital purchases that disappear after you
                    buy them, Generos gems keep working for you. When you gift
                    gems, you earn vaults (Gencoin generators) that create
                    ongoing earning potential while supporting causes you care
                    about.
                  </p>
                  <p className="text-2xl text-white mb-8 w-full">
                    <span className="flex justify-center font-bold text-white text-center w-full">
                      Virtual Good, Real Value:
                    </span>
                  </p>

                  <ul className="text-2xl text-white mb-8 space-y-4 list-none pl-4">
                    {potentialPoints.map((point, index) => (
                      <li
                        key={index}
                        className="flex items-start justify-start text-left"
                      >
                        <span className="text-primary-1 mr-2">•</span>
                        {point}
                      </li>
                    ))}
                  </ul>

                  <p className="text-2xl text-white mb-6 italic">
                    <span className="font-bold text-primary-1 mr-2">
                      First-of-its-kind innovation:
                    </span>
                    We've created the first virtual goods that actually give
                    back to their purchasers while funding causes that matter.
                  </p>
                </div>
              </div>
            </div>

            {/* Desktop and Tablet */}
            <div className="hidden md:flex flex-col w-full mt-20">
              <div className="flex" data-aos="fade-up" data-aos-delay="500">
                <div className="flex flex-col items-start justify-center">
                  <div
                    className="flex justify-center w-full"
                    id="heading-container"
                  >
                    <div
                      ref={desktopHeadingRef}
                      className="flex justify-center h1 mb-20 text-xxl text-white text-center w-full"
                      data-aos="fade-up"
                    >
                      Unlock Virtual Goods That Actually Give Back
                    </div>
                  </div>
                  <p className="text-3xl text-white mb-8">
                    Unlike typical digital purchases that disappear after you
                    buy them, Generos gems keep working for you. When you gift
                    gems, you earn vaults (Gencoin generators) that create
                    ongoing earning potential while supporting causes you care
                    about.
                  </p>
                  <p className="text-3xl text-white mb-8">
                    <span className="font-bold text-white">
                      Virtual Good, Real Value:
                    </span>{" "}
                  </p>

                  <ul className="text-3xl text-white mb-8 space-y-4 list-none pl-4">
                    {potentialPoints.map((point, index) => (
                      <li key={index} className="flex items-start">
                        <span className="text-primary-1 mr-2">•</span>
                        {point}
                      </li>
                    ))}
                  </ul>

                  <p className="text-3xl text-white  mb-6 italic">
                    <span className="font-bold text-primary-1 mr-2">
                      First-of-its-kind innovation:
                    </span>
                    We've created the first virtual goods that reward the
                    purchaser while funding meaningful causes.
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}

export default VirtualGood;
